import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "line" ]

  connect() {
    this.video = this.element.querySelector("video")
    if (!this.video) return
    this.onTime = () => this.highlight()
    this.video.addEventListener("timeupdate", this.onTime)
  }

  disconnect() {
    this.video?.removeEventListener("timeupdate", this.onTime)
  }

  seek(event) {
    if (!this.video) return
    this.video.currentTime = Number(event.currentTarget.dataset.start)
    this.video.play()
  }

  highlight() {
    const time = this.video.currentTime
    this.lineTargets.forEach((line) => {
      const start = Number(line.dataset.start)
      const end = Number(line.dataset.end)
      const active = end > start ? time >= start && time < end : time >= start
      line.classList.toggle("is-active", active)
    })
  }
}
